/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  setIcons (state, icons) {
    state.icons = icons
  },
  setModules (state, modules) {
    state.modules = modules
  },
  setRoles (state, roles) {
    state.roles = roles
  },
  setCurrentMenuToEdit(state, menu) {
    state.currentMenuToEdit = menu
  },
  setCurrentMenuToDelete(state, menu) {
    state.currentMenuToDelete = menu
  },
  SET_UNSAVED_LAYOUT(state, value) {
    state.unsavedLayout = value
  },
  SET_CURRENT_ITEM_TO_DELETE(state, value) {
    state.currentItemToDelete = value
  },
  SET_ROLE(state, role) {
    state.role = role
  }
}
